export default "/images/book-open.svg?67a128a70b4eaa20f68b805e7ef71e42";